import _ from "lodash";
import { REHYDRATE } from "redux-persist/constants";
import { SET_MONTH_RESULT } from "./OpsManager.action.react";

const initialParamsState = [];

const OpsManagerReducer = (state = initialParamsState, action) => {
  let opsRecords;
  switch (action.type) {
    /* istanbul ignore next - react-persist function */
    case REHYDRATE:
      opsRecords = action.payload.opsRecords;
      if (opsRecords) {
        return [...state, ...opsRecords];
      } else {
        return state;
      }
    case SET_MONTH_RESULT:
      if (action.data.monthId === 0) {
        return [action.data];
      } else {
        let allMonths = _.cloneDeep(state);
        let existingMonth = _.find(allMonths, { monthId: action.data.monthId });
        if (existingMonth !== undefined)
          allMonths = allMonths.splice(allMonths.indexOf(existingMonth), 1);
        return [...allMonths, action.data];
      }

    default:
      return state;
  }
};

export { OpsManagerReducer };



// WEBPACK FOOTER //
// ./src/app/simulation/redux/OpsManager.reducer.react.js